import React from 'react'
import classnames from 'classnames'
import { Title, Icon } from 'components'

export default function Goal(props) {
  const { active, onClick, editTitle, id, icon, title, category, text } = props
  const classNames = classnames('goal', {
    active: active,
  })
  return (
    <div className={classNames} onClick={() => onClick()}>
      <Icon name={icon} />
      <div>
        <Title
          id={id}
          value={title}
          editTitle={editTitle}
          category={category}
        />
        {text}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/common/Goal.js